import { useState, useEffect, useRef } from 'react';
import { QuestionEntry } from '@wix/ambassador-faq-question-entry-v2-question-entry/types';
import { usePaginationQuestions } from './usePaginationQuestions';
import { usePaginationSearchQuestions } from './usePaginationSearchQuestions';

export const useQuestions = (initialQuestions: QuestionEntry[]) => {
  const [questionsList, setQuestionsList] = useState<QuestionEntry[]>(
    initialQuestions || [],
  );

  const bottomRef = useRef<HTMLDivElement | null>(null);

  // Manage load more logic
  usePaginationQuestions({
    bottomRef,
  });

  // Manage load more logic when searching
  usePaginationSearchQuestions({
    bottomRef,
  });

  useEffect(() => {
    setQuestionsList((prev) =>
      JSON.stringify(prev) !== JSON.stringify(initialQuestions)
        ? initialQuestions
        : prev,
    );
  }, [initialQuestions]);

  return { questionsList, bottomRef };
};
